<div *ngIf="invoice.statusFinanceiroIntegration === StatusFinanceiroIntegration.CANCELED">
    <i class="pi pi-ban red-icon" pTooltip="Cancelado"></i>
</div>

<div *ngIf="invoice.statusFinanceiroIntegration === StatusFinanceiroIntegration.CREATED">
    <i class="pi pi-check" pTooltip="Registrado"></i>
</div>

<div *ngIf="invoice.statusFinanceiroIntegration === StatusFinanceiroIntegration.WAITING">
    <i class="pi pi-spinner" pTooltip="Aguardando"></i>
</div>

<div *ngIf="invoice.statusFinanceiroIntegration === StatusFinanceiroIntegration.ERROR">
    <i class="pi pi-times red-icon cursor-pointer" (click)="updateInvoice()" pTooltip="Erro: clique para ver e reenviar"></i>
</div>
